// ======================================================================
// File Name       : authed
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import {
  IMPORT_S3_SIGNED_URL, LOGOUT, RECEIVE_AUTHED_USER, UPDATE_AUTH_USER_INFO, UPDATE_AUTH_USER_SERVICE
} from '../constants/ActionTypes';
import * as SessionStorageUtils from '../utils/SessionStorageUtils';
import * as Path from '../constants/PathConstants';

const initialState = {
  authedUser: {
    userInfo: {},
    managementFunctionAuthorityInfo: {},
  },
  logined: false,
  functions: {},
  topNavigatorDatas: [],
  leftNavigatorDatas: [],
  routes: {},
  s3SignedUrl: '', // #7287
};

export default function auth(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_AUTHED_USER: {
      const { authedUser, functions, routes, topNavigatorDatas, leftNavigatorDatas } = action;
      // Sprint_20230508 #33 START
      const { isTrialExpire } = authedUser;
      // Sprint_20230508 #33 END
      return {
        ...state,
        ...{ authedUser, functions, routes, topNavigatorDatas, leftNavigatorDatas },
        ...{ logined: true },
      };
    }

    case UPDATE_AUTH_USER_SERVICE: {
      const {
        newAuthedUser,
        newFunctions,
        newRoutes,
        newTopNavigatorDatas,
        newLeftNavigatorDatas,
      } = action;
      return {
        ...state,
        ...{
          authedUser: newAuthedUser,
          functions: newFunctions,
          routes: newRoutes,
          topNavigatorDatas: newTopNavigatorDatas,
          leftNavigatorDatas: newLeftNavigatorDatas,
        },
        ...{ logined: true },
      };
    }

    case UPDATE_AUTH_USER_INFO: {
      const { newUserInfo } = action;
      const { authedUser } = state;
      const userInfo = { ...authedUser.userInfo };
      if (newUserInfo) {
        newUserInfo.userName && (userInfo.userName = newUserInfo.userName);
        if (newUserInfo.loginId) {
          (userInfo.loginId = newUserInfo.loginId);
          SessionStorageUtils.save('loginId', newUserInfo.loginId);
        }
      }
      const newAuthedUser = {
        ...authedUser,
        userInfo,
      };
      return {
        ...state,
        authedUser: newAuthedUser,
      };
    }

    // #7287 START
    case IMPORT_S3_SIGNED_URL: {
      const { s3SignedUrl } = action;
      return {
        ...state,
        ...{ s3SignedUrl },
      };
    }
    // #7287 END

    case LOGOUT: {
      return { ...initialState };
    }

    default:
      return state;
  }
}
